
<template>
    <div v-if="$store.state.loader==1" class="z2000 pf ov bgw70">
      <img src="@/assets/imgs/loader.gif" alt="" class="g_nm cc" style="width: 150px;">
    </div>
    <div class="ov ba  m_pt10 z10 l">
      <div class="ml100 md_ml60 m_ml40 m_m_ml20 pv10 m_pv5">
        <img src="@/assets/imgs/logoW.png" alt="" class="w100 headerLogo">
      </div>
    </div>
    <div>
      <div class="whyalula_hcontainer" :style="{ backgroundImage: 'url(' + require('@/assets/imgs/bannerNew.webp') + ')' }">
        <div class="ov ra ba ml100 md_ml60 m_ml40 m_m_ml20 m_ml50 l" style="top:30%">
          <div class="fs70 ld_fs60 md_fs50 m_fs30 m_m_fs20 lh70 ld_lh60 md_lh50 m_lh30 m_m_lh20  cBeige upper">{{ $t('ALULA') }}</div>
          <div class="fs30 ld_fs26 md_fs24 m_fs20 m_m_fs15 lh36 ld_lh30 md_lh28 m_lh24 m_m_lh20 cBeige ">
            <p>{{ $t('Conference of Emerging') }}</p>
          <p>{{ $t('Market Economies') }}</p>
          </div>
        </div>
      </div>
        
    </div>
    <div class="cov bgBeige"  :style="{ backgroundImage: 'url(' + require('@/assets/imgs/bg.jpg') + ')' }">
      <router-view></router-view>
    </div>
    <footer class="cov pt20 pb40" style="background-position:left bottom" :style="{ backgroundImage: 'url(' + require('@/assets/imgs/footer.png') + ')' }">
      <div class="fs0">
        <div class="g_nm p5"><a href="https://x.com/AlUlaCEME" target="_blank"><img class="footerIcon pointer" src="@/assets/imgs/footerX.svg" style="width:40px;" alt=""></a></div>
        <div class="g_nm p5"><a href="https://www.youtube.com/@AlUlaCEME" target="_blank"><img class="footerIcon pointer" src="@/assets/imgs/youtubeFooter.png" style="width:40px;" alt=""></a></div>
        <!-- <div class="g_nm p5"><a href="https://www.instagram.com/alulaceme?igsh=ZzNodnFxbXJzd2xo" target="_blank"><img class="footerIcon pointer" src="@/assets/imgs/footerI.svg" style="width:40px;" alt=""></a></div> -->
        <div class="g_nm p5"><a href="https://www.linkedin.com/company/alula-conference-for-emerging-market-economies/" target="_blank"><img class="footerIcon pointer" src="@/assets/imgs/footerL.svg" style="width:40px;" alt=""></a></div>
        <div class="g_nm p5"><a href="https://www.facebook.com/share/1EGmEFp4FP/?mibextid=wwXIfr" target="_blank"><img class="footerIcon pointer" src="@/assets/imgs/footerF.svg" style="width:40px;" alt=""></a></div>      </div>
      <div class="mt30  ph10">
          <div class="g_nm vm ph50 m_ph40 m_h">
            <div class="ov ml30 ba  pt2 bgBeige"></div>
            <img src="@/assets/imgs/sqW.svg" class="ov ra ba " alt="" style="width: 30px; top:-9.5px">
          </div>
          <div class="g_nm vm fs18 m_fs16 m_m_fs13 b cBeige ph20 m_m_ph15 upper">{{ $t('organized by') }}</div>
          <div class="g_nm vm ph50 m_ph40 m_h">
            <div class="ov mr30 ba  pt2 bgBeige"></div>
            <img src="@/assets/imgs/sqW.svg" class="ov la ba " alt="" style="width: 30px; top:-9.5px">
          </div>
      </div>
      <img src="@/assets/imgs/logoFooter.png" alt="" style="max-width:300px;" class="mt10 w100">
      <div class="mt10 ">
          <div class="g_nm vm ph50 m_ph40 md_h m_ph20 m_m_ph20">
            <div class="ov ml20 ba  pt2 bgBeige"></div>
            <img src="@/assets/imgs/sqW.svg" class="ov ra ba " alt="" style="width: 20px; top:-6px">
          </div>
          <div class="g_nm vm fs18 m_fs12 b cBeige ph20 m_ph8 m_m_ph5">© 2025 AlUla Conference for Emerging Market Economies. All Rights Reserved.</div>
          <div class="g_nm vm ph50 m_ph40 md_h m_ph20 m_m_ph20">
            <div class="ov mr20 ba  pt2 bgBeige"></div>
            <img src="@/assets/imgs/sqW.svg" class="ov la ba " alt="" style="width: 20px; top:-6px">
          </div>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'RegLayout',
  created(){
    if(this.$cookies.isKey("_AUlaLang")){
      if(this.$cookies.get("_AUlaLang")=='en'){
        this.$i18n.locale='ar';
      }
      else{
        this.$i18n.locale='en';
      }
      this.changeLang()
    }
  },
  
  methods: {
    
    changeLang(){
      if(this.$i18n.locale=="en"){
        $('html').attr('lang', 'ar');  
        this.$i18n.locale='ar';
        $('body').addClass('rtl');
        const expirationTime =  100 * 60 * 60;
        this.$cookies.set("_AUlaLang", 'ar', expirationTime);
      }
      else{
        $('html').attr('lang', 'en');  
        this.$i18n.locale='en';
        $('body').removeClass('rtl');
        const expirationTime =  100 * 60 * 60;
        this.$cookies.set("_AUlaLang", 'en', expirationTime);
      }
    },
  }
}
</script>
<style>
.headerLogo{max-width: 80px;}
@media all and (max-width:768px){
.headerLogo{max-width: 50px;}
}
</style>